// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__9Z4yE","clinicsSelect":"TableHeading_clinicsSelect__2CBSn"};